import * as RadixPopover from '@radix-ui/react-popover';
import styled from 'styled-components/macro';
import {
  overlaySlideInBottom,
  overlaySlideInLeft,
  overlaySlideInRight,
  overlaySlideInTop,
  overlaySlideOutBottom,
  overlaySlideOutLeft,
  overlaySlideOutRight,
  overlaySlideOutTop,
} from '../_core/overlay/overlay.animations';
import { BaseContent, BaseScrollArea } from '../_core/overlay/overlay.styled';

export const StyledContent = styled(RadixPopover.Content)`
  ${BaseContent};
  z-index: 9999;
  padding: 0;
  min-width: var(--radix-popover-trigger-width);
  max-width: var(--radix-popover-content-available-width);
  max-height: var(--radix-popover-content-available-height);
  transform-origin: var(--radix-popover-content-transform-origin);

  &[data-state='open'] {
    &[data-side='top'] {
      animation-name: ${overlaySlideInTop};
    }
    &[data-side='right'] {
      animation-name: ${overlaySlideInRight};
    }
    &[data-side='bottom'] {
      animation-name: ${overlaySlideInBottom};
    }
    &[data-side='left'] {
      animation-name: ${overlaySlideInLeft};
    }
  }

  &[data-state='closed'] {
    &[data-side='top'] {
      animation-name: ${overlaySlideOutTop};
    }
    &[data-side='right'] {
      animation-name: ${overlaySlideOutRight};
    }
    &[data-side='bottom'] {
      animation-name: ${overlaySlideOutBottom};
    }
    &[data-side='left'] {
      animation-name: ${overlaySlideOutLeft};
    }
  }
`;

export const ScrollArea = styled.div`
  ${BaseScrollArea};
`;
